import React from "react";
import { connect } from "react-redux";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";
import Moment from "moment"

class InformacionGeneral extends React.PureComponent {

  render() {
    const _data = this.props.dataSelected;    
    return (
      <React.Fragment>
        {this.props.isLoading && <LoadingOverlay />}
        <div
          className="row"
          style={{
            margin: "10px 0 10px 0",
            borderTop: "1px solid #ddd",
            paddingTop: 10,
          }}
        >
        </div>
        <div className="row">
          <div className="col-3">Empresa solicitante: </div>
          <div className="col-9" style={{ fontWeight: "bold" }}>{_data && _data.CompanyName ? _data.CompanyName : ""}</div>
        </div>
        <br />
        <div className="row">
          <div className="col-3">Centro de costos: </div>
          <div className="col-9" style={{ fontWeight: "bold" }}>{_data && _data.CostCenter ? _data.CostCenter : ""}</div>
        </div>
        <br />
        <div className="row">
          <div className="col-3">Solicitante: </div>
          <div className="row" style={{ paddingLeft: 14 }}>
            <div className="col-9" style={{ fontWeight: "bold" }}>{_data && _data.PetitionerName ? _data.PetitionerName : ""}</div>
            <div className="col-9">{_data && _data.AuthorizedRut ? _data.AuthorizedRut : ""}</div>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-3">Fecha preferente: </div>
          <div className="col-9">{(_data && _data.ProposalDate ? Moment(_data.ProposalDate).format("DD/MM/YYYY") : " ") + (_data && _data.ProposalDateEnd ? "  -  " + Moment(_data.ProposalDateEnd).format("DD/MM/YYYY") : " ")}</div>
        </div>
        <br />
        <div className="row">
          <div className="col-3">Trabajadores: </div>
          <div className="col-9">{_data && _data.WorkersQuota ? _data.WorkersQuota : ""}</div>
        </div>
        <br />
        <div className="row">
          <div className="col-3">Tipo de evaluación: </div>
          <div className="col-9">{_data && _data.RequestTypeDescription ? _data && _data.RequestTypeDescription : ""}</div>
        </div>
        <br />
        <div className="row">
          <div className="col-3">Centro de atención: </div>
          <div className="col-9">{_data && _data.defaultCityDescription ? _data.defaultCityDescription : ""}</div>
        </div>
        <br />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.confirmacionSolicitudesAgendaSel.isLoading,
  id: state.confirmacionSolicitudesAgendaSel.modalGestionar.id,
  dataSelected: state.confirmacionSolicitudesAgendaSel.dataSelected
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(InformacionGeneral);

